import { Component, ElementRef, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SVGIcon, xIcon } from '@progress/kendo-svg-icons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { EsAnalyticsService, BreakthroughIncidentsAnalysisResponse } from '../../../services/es-analytics.service';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/core/shared/common/base.component';

@Component({
  selector: 'app-breakthrough-incidents-analysis',
  templateUrl: './breakthrough-incidents-analysis.component.html',
  styleUrls: ['./breakthrough-incidents-analysis.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonsModule, IconsModule],
  providers: [EsAnalyticsService],
})
export class BreakthroughIncidentsAnalysisComponent extends BaseComponent {
  private _organizationId: number | null = null;
  
  @Input() 
  set organizationId(value: number | null) {
    this._organizationId = value;
    this.loadAnalysisData();
  }
  
  get organizationId(): number | null {
    return this._organizationId;
  }

  @Output() close = new EventEmitter<void>();

  public xIcon: SVGIcon = xIcon;
  private esAnalyticsService = inject(EsAnalyticsService);
  
  public analysisData: BreakthroughIncidentsAnalysisResponse | null = null;
  public isLoading = false;

  ngOnInit(): void {
    // Load data even if organizationId is not set (for mock data)
    this.loadAnalysisData();
  }

  private loadAnalysisData(): void {
    this.isLoading = true;
    // For mock data, we can pass null or a default value
    this.esAnalyticsService
      .getBreakthroughIncidentsAnalysis(this._organizationId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (data) => {
          this.analysisData = data;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading breakthrough incidents analysis:', error);
          this.isLoading = false;
        },
      });
  }

  public onClose(): void {
    this.close.emit();
  }

  public exportReport(): void {
    // TODO: Implement report export functionality
    console.log('Export report clicked');
  }

  public configureRules(): void {
    // TODO: Implement rule configuration functionality
    console.log('Configure rules clicked');
  }

  public getPriorityClass(priority: string): string {
    switch (priority.toLowerCase()) {
      case 'high':
        return 'priority-high';
      case 'medium':
        return 'priority-medium';
      case 'low':
        return 'priority-low';
      default:
        return 'priority-medium';
    }
  }

  public getEffortClass(effort: string): string {
    switch (effort.toLowerCase()) {
      case 'high':
        return 'effort-high';
      case 'medium':
        return 'effort-medium';
      case 'low':
        return 'effort-low';
      default:
        return 'effort-medium';
    }
  }
}